import React, { useState, useRef, ReactNode, useEffect } from 'react';
import styled from 'styled-components';
import Tooltip, { TooltipPlacement, TooltipProps } from 'features/shared/Tooltip';
interface ITableRowWithTooltip {}
const Wrap = styled.div``;
const Inner = styled.div`
  white-space: nowrap;
  overflow: hidden;
`;
const SmartTooltip = ({ needTooltip, ...props }: TooltipProps & { needTooltip: boolean; children: ReactNode }) =>
  needTooltip ? <Tooltip {...props}>{props.children}</Tooltip> : <>{props.children}</>;
const TableRowWithTooltip = (props: React.PropsWithChildren<ITableRowWithTooltip>) => {
  const wrapRef = useRef<HTMLDivElement>(null);
  const innerRef = useRef<HTMLDivElement>(null);
  const [needTooltip, setNeedTooltip] = useState(false);
  useEffect(() => {
    if (wrapRef.current && innerRef.current) {
      if (innerRef.current.scrollWidth > innerRef.current.offsetWidth) {
        setNeedTooltip(true);
      } else {
        setNeedTooltip(false);
      }
    }
  }, [props.children]);

  return (
    <Wrap ref={wrapRef}>
      <SmartTooltip
        needTooltip={needTooltip}
        title={props.children as string}
        arrow
        placement={TooltipPlacement.Bottom}
        width={wrapRef.current?.offsetWidth}
        minWidth={220}
      >
        <Inner ref={innerRef} style={{ textOverflow: needTooltip ? 'ellipsis' : 'none' }}>
          {props.children}
        </Inner>
      </SmartTooltip>
    </Wrap>
  );
};

export default TableRowWithTooltip;
